<template>
  <div>
    <div>
   <the-header/>
   </div>
   <router-view/>
   <the-live-chat></the-live-chat>
   <div>
   <the-footer/>
  </div>
  </div>
 
 </template>
 
 <script>
//  import TheHeader from './components/layout/Header.vue';
//  import TheFooter from './components/layout/Header.vue';
 import { TheHeader, TheFooter } from 'vue3-header-footer';
 import { TheLiveChat } from 'vue3-live-chat';
 
 export default{
   name:"App",
   components:{
     TheHeader,
     TheFooter,
     TheLiveChat
   }
 }
 </script>
 
 <style>
 @import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700");
 @import "../node_modules/bootstrap/dist/css/bootstrap.css";
 @import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
 @import 'vue-multiselect/dist/vue-multiselect.css';
 @import "assets/css/custom_Multiselect.scss";
 @import "assets/css/custom_Suggestions.scss";

 
.v-table > .v-table__wrapper > table{
    min-width: 600px !important;
}
 .dropdown-header, .nav-link.inline-block, .category-title.nav-link {
   padding: 0px !important;
 }
 .home.mchp-button-wrapper {
   display: block !important;
 }
 .searchBox {      
  padding-inline:calc(2% + 85px);
   margin: 30px auto;
 }
 .mchp-searchbar .mchp-searchbar-input {
   border: 1px solid #c4c4c4 !important;
 }
 .mchp-searchbar .search-container .search-dropdown {
   border-width: 1px 0 1px 1px !important;
   border-style: solid !important;
   border-color: #f0f0ee !important;
   border-radius: 4px 0 0 4px !important;
   border: 1px solid #c4c4c4 !important;
   border-right-width: 0 !important;
 }

 /* CSS for header dropdown */
  #search-drop-down{
  border-radius: 4px 0 0 4px !important;
  border: 1px solid #c4c4c4 !important;
  border-right-width: 0 !important;
  height: 46px !important; 
   -webkit-appearance: menulist !important; 
  -moze-appearance: menulist !important; 
  appearance: menulist !important; 
 } 
 .slds-icon{
  width:20px;
 } 
 .chat-footer > button:not(.btn-cancel) {
  color: #ffffff
 }
 .multiselect__placeholder {
   color: #737373 !important;
 }
 .col-md-12 {
   padding-right: 0px !important;
   padding-left: 0px !important;
 }
 .row {
   margin-left: 0px !important;
   margin-right: 0px !important;
 }
 .divHeader {
   margin: 0px !important;
 }
 .multiselect__select:focus {
   outline: none;
 }
 .mchp-button-wrapper:focus-within {
   border: none;
   padding: 0;
 }
 @media (max-width: 1020px) {
   nav {
       position: static;
       height: 0px;
       background: transparent;
       -webkit-tap-highlight-color: rgba(255, 255, 255, 0.15);
   }
 }

 .mchp-searchbar .search-container .search-dropdown {
   border-radius: 4px 4px 4px 4px !important;
   border-width: 1px 1px 1px 1px !important;
 }
 
 </style>
 
 <!-- <style src="../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style> -->